export function toLowerCase(str: any) {
  if (str) {
    return str.toLowerCase();
  }
  return str;
}
